import { Grid, Paper } from "@material-ui/core";
import { MasterButton, SearchInput, Title } from "App/Component/ui";
import { isNull } from "App/utils/helpers";
import { STYLE_MASTER_SATU_SEHAT_ORGANISASI } from "pages/SatuSehat/Organisasi/ui/helpers";
import React, { useContext, useEffect, useState } from "react";
import { OrganisasiCtx } from "../context/context";
import {
	STATE_INFO,
	STATE_LOKASI,
	STATE_KONTAK,
	STATE_ALAMAT,
} from "./helpers";
import { useReloadTableOrganisasi } from "./hooks";
import OrganisasiPreview from "./OrganisasiPreview";
import OrganisasiTable from "./OrganisasiTable";

const OrganisasiWrapper = () => {
	const classes = STYLE_MASTER_SATU_SEHAT_ORGANISASI();
	const { state } = useContext(OrganisasiCtx);
	const rows = state.organisasi.body;
	const totalData = state.organisasi.count;
	const [open, setOpen] = useState(false);

	const [formDataInfo, setFormDataInfo] = useState(STATE_INFO);
	const [showModalLokasi, setShowModalLokasi] = useState(false);
	const [lokasi, setLokasi] = useState(STATE_LOKASI);
	const [formDataAlamat, setFormDataAlamat] = useState(STATE_ALAMAT);
	const [alamat, setAlamat] = useState([]);
	const [formDataKontak, setFormDataKontak] = useState(STATE_KONTAK);
	const [telecom, setTelecom] = useState([]);

	const [children, setChildren] = useState([]);
	const [infoChildren, setInfoChildren] = useState("");

	const toggleDrawer = (open) => (event) => {
		if (
			event.type === "keydown" &&
			(event.key === "Tab" || event.key === "Shift")
		) {
			return;
		}
		setOpen(open);
	};

	const {
		resetPagination,
		setNewData,
		pagination,
		onPrevious,
		onNext,
		handleClickPageNumber,
		handleChangeLimit,
		loading,
		handleChange,
		formFilter,
		setFormFilter,
	} = useReloadTableOrganisasi();

	useEffect(() => {
		setNewData();
	}, []);

	const handleOpenOrganisasi = async () => {
		setFormDataInfo({
			...STATE_INFO,
			id_organization:
				children.length === 0
					? ""
					: children[children.length - 1].id_organization,
			isUpdate: false,
			id: children.length === 0 ? "" : children[children.length - 1].id,
		});
		setFormDataAlamat(STATE_ALAMAT);
		setFormDataKontak(STATE_KONTAK);
		setLokasi(STATE_LOKASI);
		setAlamat([]);
		setTelecom([]);
		setOpen((prev) => !prev);
	};

	const handleEditOrganisasi = async (row) => {
		const isAddress = Object.keys(row.address).length === 0;
		const isContact = Object.keys(row.telecom).length === 0;

		try {
			setFormDataInfo({
				id_organization: row.id_organization,
				parent_id_organization: row.parent_id_organization,
				kode: row.kode,
				name: row.name,
				alias: row.alias,
				active: row.active,
			});
			setFormDataAlamat({
				...STATE_ALAMAT,
				available: isAddress ? false : true,
			});
			setFormDataKontak({
				...STATE_KONTAK,
				available: isContact ? false : true,
			});
			setLokasi({
				id_lokasi: row.id_location,
				nama: row.nama_loction,
			});
			setAlamat(row.address);
			setTelecom(row.telecom);
			setOpen((prev) => !prev);
		} catch (error) {
			console.log(error);
		}
	};

	const handleChildren = async (row) => {
		await setNewData(1, 10, {
			parent_id_organization: row.id_organization,
			name: "",
		});

		setChildren([
			...children,
			isNull(row.parent_id_organization)
				? {
						id_organization: row.id_organization,
						id: row.id,
						parent_id_organization: "",
				  }
				: {
						id_organization: row.id_organization,
						id: row.id,
						parent_id_organization: row.parent_id_organization,
				  },
		]);

		if (isNull(row.parent_id_organization)) {
			setInfoChildren(row.kode);
		} else {
			setInfoChildren(`${infoChildren}/${row.kode}`);
		}
	};

	const handleBackOrganisasi = async () => {
		if (children.length === 1) {
			setChildren([]);
			setNewData(1, 10, {
				parent_id_organization: "",
				id_organization: "",
				name: "",
			});

			setInfoChildren("");
		} else {
			const id = children[children.length - 1].id_organization;
			const filterID = children.filter((x) => x.id_organization !== id);
			await setNewData(1, 10, {
				parent_id_organization: filterID[filterID.length - 1].id_organization,
				name: "",
			});
			setChildren(filterID);

			const forPosisi = infoChildren.split("/");
			const filterPosisi = forPosisi[forPosisi.length - 1];
			const lastPosition = forPosisi.filter((x) => x !== filterPosisi);
			setInfoChildren(lastPosition.join("/"));
		}
	};

	const handleSearch = async (row) => {
		setNewData(1, 10, {
			name: row,
			parent_id_organization: "",
		});
	};

	return (
		<>
			<Title title="Satu Sehat - Organisasi" />
			<Paper className={classes.paper}>
				<div className="mb-1">
					<Grid
						container
						direction="row"
						spacing={1}
						alignItems="center"
						justifyContent="space-between"
					>
						<p className="fw-200 fs-16">
							{isNull(infoChildren) ? "" : infoChildren}
						</p>
						<div
							style={{
								display: "flex",
								gap: "10px",
							}}
						>
							<SearchInput
								withIcon={true}
								onchange={(e) => handleSearch(e.target.value)}
							/>
							<MasterButton
								type="submit"
								name={"Tambah Organisasi"}
								size="md"
								onClick={() => handleOpenOrganisasi()}
							/>
							{children.length === 0 ? (
								<></>
							) : (
								<MasterButton
									type="submit"
									name={"Kembali"}
									size="md"
									color="warning"
									onClick={() => handleBackOrganisasi()}
								/>
							)}
						</div>
					</Grid>
				</div>

				<OrganisasiPreview
					open={open}
					setOpen={setOpen}
					toggleDrawer={toggleDrawer}
					formDataInfo={formDataInfo}
					setFormDataInfo={setFormDataInfo}
					showModalLokasi={showModalLokasi}
					setShowModalLokasi={setShowModalLokasi}
					lokasi={lokasi}
					setLokasi={setLokasi}
					formDataAlamat={formDataAlamat}
					setFormDataAlamat={setFormDataAlamat}
					alamat={alamat}
					setAlamat={setAlamat}
					formDataKontak={formDataKontak}
					setFormDataKontak={setFormDataKontak}
					telecom={telecom}
					setTelecom={setTelecom}
					setNewData={setNewData}
				/>

				<OrganisasiTable
					rows={rows}
					handleClickEdit={handleEditOrganisasi}
					handleChildren={handleChildren}
					totalData={totalData}
					resetPagination={resetPagination}
					setNewData={setNewData}
					pagination={pagination}
					onPrevious={onPrevious}
					onNext={onNext}
					handleClickPageNumber={handleClickPageNumber}
					handleChangeLimit={handleChangeLimit}
					loading={loading}
					handleChange={handleChange}
					children={children}
				/>
			</Paper>
		</>
	);
};

export default OrganisasiWrapper;
